<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <!-- <h5 class="mb-0">
        Bank Details
      </h5> -->
      <!-- <b-badge variant="light-primary">
        Basic
      </b-badge> -->
      <!-- <small class="text-muted w-100">July 22, 2021</small> -->
    </b-card-header>

    <b-card-body>
      <ul
        v-if="userData.bank_details"
        class="list-unstyled my-1"
      >
        <li>
          <strong>Transactions:</strong> <span class="align-middle text-success">({{ userData.stats.count }})</span>
        </li>
        <li class="my-25">
          <strong>Amount:</strong> <span class="align-middle text-primary">({{ userData.stats.yearly }})</span>
        </li>
      </ul>
      <div
        v-else
        class="text-center"
      >
        <p>No transaction details </p>
      </div>
        <h6>KYC</h6>
        <div v-if="userData.kyc && userData.kyc.length">
          <div class="" v-for="kyc in userData.kyc" :key="kyc.id" >
            <strong>{{kyc.name}}</strong>
            <p class="mb-0 mt-0 d-flex justify-content-between align-items-center">
              <a :href="kyc.value" target="_blank">View</a>
              <button 
                type="button" 
                class="btn btn-transparent btn-sm text-primary"
                v-b-modal.event-kyc-modal
                v-show="kyc.name !== 'BVN'"
              >Change</button>
            </p>
          </div>
        </div>
        <div v-else>
          <p>No KYC document uploaded</p>
          <button 
            type="button" 
            class="btn btn-primary btn-sm"
            v-b-modal.event-kyc-modal
          >Upload Document</button>
        </div>
      <b-button
        v-if="userData.status === 'Not Verified'"
        id="approve"
        type="button"
        ripple
        variant="primary"
        @click="manageAccount($event)"
        class="mt-2"
      >
        Activate
        <b-spinner
          v-show="loading"
          small
          variant="light"
        />
      </b-button>
      <b-button
        v-else
        id="decline"
        type="button"
        ripple
        variant="danger"
        @click="manageAccount($event)"
        class="mt-2"
      >
        Deactivate
        <b-spinner
          v-show="loading"
          small
          variant="light "
        />
      </b-button>
    </b-card-body>
    <b-modal
      id="event-kyc-modal"
      content-class="shadow"
      :title="`Upload KYC `"
      centered
      size="md"
      no-close-on-backdrop
      hide-footer
      ref="kycModal"
    >
      <b-card-body>
        <p class="text-center">
          <strong>Upload KYC Document</strong>
        </p>
        <b-input-group class="mb-2 text-right">
          <b-form-select
            v-model="kyc_document_type"
            :options="kycDocumentOptions"
            required
          />
        </b-input-group>
        <b-form-file
          v-model="id_document"
          accept=".jpg,.jpeg,.png"
          placeholder="Choose a file..."
          drop-placeholder="Drop file here..."
          class="mb-2"
          @change="selectFile"
        />
        <b-button
          variant="primary"
          @click="uploadKYC"
        >
          Submit
          <b-spinner
            v-show="loading"
            small
            variant="light"
          />
        </b-button>
      </b-card-body>
      <!-- <b-button
        variant="secondary"
        @click="$refs.kycModal.hide()"
        class="mt-2"
      >
        Close
      </b-button> -->
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BButton, BSpinner, BInputGroup, BFormSelect, BFormFile
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  directives: {
    Ripple,
  },
  components: {
    BSpinner,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BInputGroup,
    BFormSelect,
    BFormFile,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      details: {},
      option: '',
      loading: false,
      kyc_document_type: '',
      id_document: null,
      kycDocumentOptions: [
        { value: '', text: 'Select KYC Type', disabled: true },
        { value: 'passport', text: 'Passport' },
        { value: 'drivers_license', text: "Driver's License" },
        { value: 'national_id', text: 'National ID' }
      ],
    }
  },
  methods: {
    manageAccount(event) {
      this.loading = true
      const details = {
        agent_id: this.userData.agent_id,
        option: event.target.id,
      }
      // console.log('details', details)
      this.$http.post(`${this.$url}/accounts/verify-account`, details)
        .then(() => {
          // console.log('===', response)
          window.location.reload()
        })
        .finally(() => {
          this.loading = false
        })
    },
    uploadKYC() {
      this.loading = true
      const formData = new FormData()
      formData.append('merchant_id', this.userData.id)
      formData.append('document_type', this.kyc_document_type)
      formData.append('id_document', this.id_document)

      axios.post(`${this.$url}/accounts/upload-kyc`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })
        .then((response) => {
          if(response.data.status === true) {
            this.$refs.kycModal.hide()
            Swal.fire({
              title: 'Success',
              text: 'KYC Document uploaded successfully',
              icon: 'success',
            })
            return
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectFile(event) {
      // console.log('File selected:', event.target.files[0])
      if (event.target.files.length === 0) {
        this.id_document = null
        return
      }
      if (event.target.files[0].size > 2 * 1024 * 1024) { // 2MB limit
        Swal.fire({
          title: 'Error',
          text: 'File size exceeds 2MB limit',
          icon: 'error',
        })
        this.id_document = null
        return
      }
      if (!['image/jpeg', 'image/png'].includes(event.target.files[0].type)) {
        Swal.fire({
          title: 'Error',
          text: 'Only JPG and PNG files are allowed',
          icon: 'error',
        })
        this.id_document = null
        return
      }
      this.id_document = event.target.files[0]
    },
  },
}
</script>

<style lang="scss">
  button {
    cursor: pointer !important;
  }
</style>
